import React, { useContext, useEffect, useRef, useState } from 'react'
import axios from 'axios';
import "./message.css";
import { useNavigate, useParams } from 'react-router-dom';
import Lottie from "react-lottie";
import animationData from "../../utils/LottieAnimation/typing.json";
import { Context } from '../../context/userContext';
import { baseUrl } from '../../config/config';
import { convertDate } from '../../utils/date.formate';
import { io } from 'socket.io-client';
import { FaCommentAlt } from 'react-icons/fa';
var socket;

const MessagePage = () => {
    const {userInfo, token, chat} = useContext(Context);    
    const [messages, setMessages] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [newMessage, setNewMessage] = useState("");
    const [socketConnected, setSocketConnected] = useState(false);
    const [typing, setTyping] = useState(false);
    const [istyping, setIsTyping] = useState(false);
    const [reciever, setReciever] = useState(null);
    const navigate = useNavigate();
    const { id } = useParams();
    const messageContainerRef = useRef(null);

    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
          preserveAspectRatio: "xMidYMid slice",
        },
      };
    
    const typingHandler = (e) => {
        setNewMessage(e.target.value);

        if (!socketConnected) return;

        if (!typing) {
        setTyping(true);
        socket.emit("typing", parseInt(id));
        }
        let lastTypingTime = new Date().getTime();
        var timerLength = 1000;
        setTimeout(() => {
        var timeNow = new Date().getTime();
        var timeDiff = timeNow - lastTypingTime;
        if (timeDiff >= timerLength && typing) {
            socket.emit("stop typing", parseInt(id));
            setTyping(false);
        }
        }, timerLength);
        
      };
    
    const fetchMessages = async () => {
        setIsLoading(true);
        try {
          const config = {
            headers: {
              Authorization: `Bearer ${token && token}`,
            },
          };
          const { data } = await axios.get(
            `${baseUrl}/message/${parseInt(id)}`,
            config
          );
          setMessages(data);
          setIsLoading(false);
          socket.emit("join room", parseInt(id));
        } catch (error) {
            console.log(error)
            setIsLoading(false);
        }
    };

    const sendMessage = async (event) => {
        event.preventDefault();
        socket.emit("stop typing", parseInt(id));
        try {
        const config = {
            headers: {
            "Content-type": "application/json",
            Authorization: `Bearer ${token &&token}`,
            },
        };
        setNewMessage("");
        const { data } = await axios.post(
            `${baseUrl}/message`,
            {
            content: newMessage,
            chatRoomId: parseInt(id),
            senderId: userInfo?.id
            },
            config
        );
        socket.emit("new message", data);
        setMessages([...messages, data]);
        } catch (error) {
            console.log(error)
        }
    };
    
    useEffect(() => {
        socket = io(baseUrl)
        socket.emit("setup", {
            id: userInfo?.id,
            email: userInfo?.email
        });
        socket.on("connected", () => setSocketConnected(true));
        socket.on("typing", () => setIsTyping(true));
        socket.on("stop typing", () => setIsTyping(false));
        socket.on("message recieved", (newMessageRecieved) => {
            console.log(newMessageRecieved)
            setMessages([...messages, newMessageRecieved]);
        });
    },[socket, messages, id]);

    useEffect(() => {
        fetchMessages();
    }, [id]);

    useEffect(() => {
        axios.get(`${baseUrl}/chat/${parseInt(id)}`)
        .then(res => {
            if(res.data){
                const destinataire = res.data.users.find((user) => user.id !== userInfo?.id)
                if(destinataire !== userInfo){
                    setReciever(destinataire)
                }
            }
        })
        .catch(err => {
            console.log(err);
        })
    }, [chat, userInfo, id]);

    useEffect(() => {
        if (messageContainerRef.current) {
          messageContainerRef.current.scrollTop = messageContainerRef.current.scrollHeight;
        }
      }, [messages]);

    if(isLoading){
        return(
            <div style={{flex:"1", justifyContent:"center", alignItems:"center"}}>
                Loading...
            </div>
        )
    }

    const lougout = () => {
        sessionStorage.clear();
        navigate('/');
    }

    const goBack = () => {
        navigate(-1)
    }

    return (
        <section className="msger">
            <header className="msger-header">
                <div className="msger-header-title">
                    <FaCommentAlt /> Ho an'i {reciever?.fiantso}
                </div>
            </header>

            <main className="msger-chat" ref={messageContainerRef}>
                {messages && messages.map((message, index) => (
                    <div key={index} style={{
                        display:"flex",
                        justifyContent: `${message.sender.id === userInfo?.id ? "flex-end" : "flex-start"}`,
                        margin:'10px 0'
                    }}>
                        <span style={{
                        padding:"10px",
                        borderRadius: "20px",
                        backgroundColor: `${message.sender.id === userInfo?.id ? "rgba(72, 207, 168, 0.8)" : "rgba(123, 146, 154, 0.82)"}`,
                        }}>
                            <p>
                                {message.content}
                            </p>
                            <p style={{fontSize:"10px", display:"flex", justifyContent:"flex-end"}}>
                                {convertDate(message.createdAt)}
                            </p>
                        </span>
                    </div>
                ))}
                {istyping && !typing && 
                <p style={{
                    display:"flex",
                    justifyContent: "flex-start",
                    margin:'10px 0',
                    // padding: "10px"
                }}>
                    <Lottie
                        options={defaultOptions}
                        width={80}
                        style={{ marginLeft: 0 }}
                    />
                </p>}
            </main>
            
            <form className="msger-inputarea" onSubmit={sendMessage}>
                <input 
                    type="text" 
                    className="msger-input" 
                    placeholder="Entrer un message..." 
                    value={newMessage}
                    onChange={typingHandler}
                />
                <button className="msger-send-btn" type='submit'>Envoyer</button>
            </form>
        </section>
    )
}

export default MessagePage;
